/*eslint no-prototype-builtins: 0*/
// @ts-ignore
export const merge = <T extends Array, K extends Array>(
    o1: T,
    o2: K,
): T & K => {
    const dest: unknown = Array.isArray(o1) ? [] : {};

    const copyTo = (source: T, target: K) => {
        if (!source || !target) {
            return;
        }
        Object.keys(source).forEach(key => {
            if (
                source.hasOwnProperty(key) &&
                typeof source[key] === 'object' &&
                source[key] !== null
            ) {
                if (!target.hasOwnProperty(key)) {
                    target[key] = Array.isArray(source[key]) ? [] : {};
                }
                copyTo(source[key], target[key]);
            } else {
                if (!source.hasOwnProperty(key) && target.hasOwnProperty(key)) {
                    return;
                }
                target[key] = source[key];
            }
        });
    };

    o1 && copyTo(o1, dest as K);
    o2 && copyTo(o2, dest as K);

    return dest as T & K;
};
